module.exports = __webpack_public_path__ + "img/big_11B03_blue.e5f282ae.png";